import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import speaking from '../data/speaking/speaking';
import conversations from '../data/conversations/conversations';
import './styles/SpeakingSelectionScreen.css';

const SpeakingSelectionScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const items = [
    { label: t('monologue'),     icon: 'mic',  color: 'var(--color-vocab)',   bgColor: 'var(--color-vocab-dim)',   data: speaking },
    { label: t('conversations'), icon: 'headphones', color: 'var(--color-writing)', bgColor: 'var(--color-writing-dim)', data: conversations },
  ];

  return (
    <div className="container">
      <BackButton to="/" label={t('home')} />
      <h2 className="page-title">{t('speaking')}</h2>
      <div className="section-cards">
        {items.map((item, index) => (
          <button className="section-card" key={index} onClick={() => navigate('/speaking-screen', { state: { speaking: item.data, title: item.label } })}>
            <div className="section-icon-container" style={{ backgroundColor: item.bgColor }}>
              <span className="section-icon" style={{ color: item.color }}><Icon name={item.icon} size={24} /></span>
            </div>
            <div className="section-card-text">
              <span className="section-card-title" style={{ color: item.color }}>{item.label}</span>
            </div>
            <span className="section-card-arrow">&rsaquo;</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SpeakingSelectionScreen;
